import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { getBillingDetails, submitBillingChange, type BillingChangeInput } from '../billing.api';

const BILLING_DETAILS_QUERY_KEY = ['account', 'billing-details'];

/** Server-state for billing details (h12-4) — TanStack Query, never Zustand. */
export function useBillingDetails() {
  return useQuery({ queryKey: BILLING_DETAILS_QUERY_KEY, queryFn: getBillingDetails });
}

export function useSubmitBillingChange() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (input: BillingChangeInput) => submitBillingChange(input),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: BILLING_DETAILS_QUERY_KEY });
    },
  });
}
